<div class="infinite-scroll-container">
  <ng-content></ng-content>
  <div id="anchor" #anchor [style.bottom]="getAnchorOffset()"></div>
</div>
